'use strict'

import * as dot from 'dot-object'
import * as _ from 'lodash'
import { sanitize } from '@/helpers/sanitize'
import configurazioniService from '@/services/configurazioniService'
import prodottiService from '@/services/prodottiService'
import movimentiService from '@/services/movimentiService'
import clientiService from '@/services/clientiService'
import moment from 'moment'

export const creaMovimenti = async function (dati, datiDefault, valoriDefault, numeroMovimento, fornitore, dataMovimento, fornitoreSuColonne, usaTagliaColore, magazzinoScelto) {
  const aliquoteIva = await configurazioniService.getConfigurazione('prodotti_aliquote_iva', 'aliquote')
  const repartiFiscali = await configurazioniService.getConfigurazione('prodotti_reparti_fiscali', 'reparti')
  const fornitori = fornitoreSuColonne ? await clientiService.getFornitori() : null
  const prodotti = dati.map(pr => {
    const pobj = dot.object({ ...pr })
    pobj.codice = sanitize(pobj.codice)
    pobj.marchio = sanitize(pobj.marchio)
    if (pobj.magazzino && pobj.magazzino.giacenza) {
      pobj.magazzino.giacenza = +(parseFloat(pobj.magazzino.giacenza)).toFixed(2)
    }
    if (pobj.custom && pobj.custom.stagione && pobj.custom.stagione.codice) {
      pobj.custom.stagione.codice = sanitize(pobj.custom.stagione.codice)
    }
    for (let c = 1; c <= 5; c++) {
      let c_codice = String(_.get(pobj, `varianti.variante${c}.codice`, ''))
      let c_desc = String(_.get(pobj, `varianti.variante${c}.descrizione`, ''))
      if (c_codice.length !== 0 || c_desc.length !== 0) {
        if (c_codice.length === 0) {
          c_codice = c_desc
        }
        if (c_desc.length === 0) {
          c_desc = c_codice
        }
        c_codice = sanitize(c_codice)
        _.set(pobj, `varianti.variante${c}.codice`, c_codice)
        _.set(pobj, `varianti.variante${c}.descrizione`, c_desc)
      }
    }
    for (let c = 1; c <= 5; c++) {
      let c_codice = String(_.get(pobj, `statistici.categoria${c}.codice`, ''))
      let c_desc = String(_.get(pobj, `statistici.categoria${c}.descrizione`, ''))
      if (c_codice.length !== 0 || c_desc.length !== 0) {
        if (c_codice.length === 0) {
          c_codice = c_desc
        }
        if (c_desc.length === 0) {
          c_desc = c_codice
        }
        c_codice = sanitize(c_codice)
        _.set(pobj, `statistici.categoria${c}.codice`, c_codice)
        _.set(pobj, `statistici.categoria${c}.descrizione`, c_desc)
      }
    }    
/*     if (pobj.varianti && pobj.varianti.variante1 && pobj.varianti.variante1.codice) {
      pobj.varianti.variante1.codice = String(pobj.varianti.variante1.codice).toLowerCase() 
    }
    if (pobj.varianti && pobj.varianti.variante2 && pobj.varianti.variante2.codice) {
      pobj.varianti.variante2.codice = String(pobj.varianti.variante2.codice).toLowerCase() 
    } */
    let iva = aliquoteIva.find(x => String(x.codice) === String(pobj.appoggio.aliquota))
    let reparto = repartiFiscali.find(x => String(x.codice).toUpperCase() === String(pobj.appoggio.repartoFiscale).toUpperCase() || String(x.stampante.numero).toUpperCase() === String(pobj.appoggio.repartoFiscale))
    delete pobj.appoggio // toglie tutti i dati che non devono andare nel db prodotti
    _.merge(pobj, datiDefault)
    if (iva && reparto) {
      delete pobj.datiFiscali
      pobj.datiFiscali = {
        aliquoteIva: [{
          codice: iva.codice,
          valore: iva.aliquota,
          descrizione: iva.descrizione,
          tipoApplicazione: 'banco' // eventualmente passare
        }],
        reparto: {
          codice: reparto.codice,
          descrizione: reparto.descrizione,
          stampante: reparto.stampante.numero
        }
      }
    }
    if (pobj.magazzino.prezzoAcquisto) {
      pobj.magazzino.prezzoAcquisto = +parseFloat(pobj.magazzino.prezzoAcquisto).toFixed(2)
    }

    pobj.magazzino.unitaMisura = pobj.magazzino.unitaMisura || 'n'

    if (pobj.prezzo.L1 && pobj.prezzo.L1.base) pobj.prezzo.L1.base = +parseFloat(pobj.prezzo.L1.base).toFixed(2)
    if (pobj.prezzo.L2 && pobj.prezzo.L2.base) pobj.prezzo.L2.base = +parseFloat(pobj.prezzo.L2.base).toFixed(2)
    if (pobj.prezzo.L3 && pobj.prezzo.L3.base) pobj.prezzo.L3.base = +parseFloat(pobj.prezzo.L3.base).toFixed(2)
    if (pobj.prezzo.L4 && pobj.prezzo.L4.base) pobj.prezzo.L4.base = +parseFloat(pobj.prezzo.L4.base).toFixed(2)
    if (pobj.prezzo.L5 && pobj.prezzo.L5.base) pobj.prezzo.L5.base = +parseFloat(pobj.prezzo.L5.base).toFixed(2)

    delete pobj.codiceFornitore
    return pobj
  })

  const dataJS = moment(dataMovimento, 'YYYY-MM-DD').utcOffset(0, true).format()
  let ordinamento = 0
  let movimenti = dati.map(pr => {
    ordinamento++
    const pobj = dot.object(pr)
    pobj.codice = sanitize(pobj.codice)
    pobj.marchio = sanitize(pobj.marchio)
    if (pobj.magazzino && pobj.magazzino.giacenza) {
      pobj.magazzino.giacenza = +(parseFloat(pobj.magazzino.giacenza)).toFixed(2)
    }
    if (pobj.custom && pobj.custom.stagione && pobj.custom.stagione.codice) {
      pobj.custom.stagione.codice = sanitize(pobj.custom.stagione.codice)
    }    
    for (let c = 1; c <= 5; c++) {
      let c_codice = String(_.get(pobj, `varianti.variante${c}.codice`, ''))
      let c_desc = String(_.get(pobj, `varianti.variante${c}.descrizione`, ''))
      if (c_codice.length !== 0 || c_desc.length !== 0) {
        if (c_codice.length === 0) {
          c_codice = c_desc
        }
        if (c_desc.length === 0) {
          c_desc = c_codice
        }
        c_codice = sanitize(c_codice)
        _.set(pobj, `varianti.variante${c}.codice`, c_codice)
        _.set(pobj, `varianti.variante${c}.descrizione`, c_desc)
      }
    }
    for (let c = 1; c <= 5; c++) {
      let c_codice = String(_.get(pobj, `statistici.categoria${c}.codice`, ''))
      let c_desc = String(_.get(pobj, `statistici.categoria${c}.descrizione`, ''))
      if (c_codice.length !== 0 || c_desc.length !== 0) {
        if (c_codice.length === 0) {
          c_codice = c_desc
        }
        if (c_desc.length === 0) {
          c_desc = c_codice
        }
        c_codice = sanitize(c_codice)
        _.set(pobj, `statistici.categoria${c}.codice`, c_codice)
        _.set(pobj, `statistici.categoria${c}.descrizione`, c_desc)
      }
    }    
/*     if (pobj.varianti && pobj.varianti.variante1 && pobj.varianti.variante1.codice) {
      pobj.varianti.variante1.codice = String(pobj.varianti.variante1.codice).toLowerCase() 
    }
    if (pobj.varianti && pobj.varianti.variante2 && pobj.varianti.variante2.codice) {
      pobj.varianti.variante2.codice = String(pobj.varianti.variante2.codice).toLowerCase() 
    } */
    let iva = aliquoteIva.find(x => String(x.codice) === String(pobj.appoggio.aliquota))
    let reparto = repartiFiscali.find(x => String(x.codice).toUpperCase() === String(pobj.appoggio.repartoFiscale).toUpperCase() || String(x.stampante.numero).toUpperCase() === String(pobj.appoggio.repartoFiscale))
    _.merge(pobj, datiDefault)
    if (iva && reparto) {
      delete pobj.datiFiscali
      pobj.datiFiscali = {
        aliquoteIva: [{
          codice: iva.codice,
          valore: iva.aliquota,
          descrizione: iva.descrizione,
          tipoApplicazione: 'banco' // eventualmente passare
        }],
        reparto: {
          codice: reparto.codice,
          descrizione: reparto.descrizione,
          stampante: reparto.stampante.numero
        }
      }
    }
    const prezzo = pr.prezzo[valoriDefault.listinoVendita].base
    const acquisto = pr.magazzino.prezzoAcquisto
    const fornitoreMovimento = fornitore || fornitori.find(x => x.codice === pobj.codiceFornitore) || {}
    return {
      data: dataJS,
      prodotto: {
        codice: usaTagliaColore ? (sanitize(pr.codice) + sanitize(pr.varianti.variante1.codice || '') + sanitize(pr.varianti.variante2.codice || '')).toLowerCase() : sanitize(pr.codice).toLowerCase(),
        quantita: pr.appoggio.quantita || 0,
        um: pr.magazzino.unitaMisura,
        prezzoUnitario: prezzo,
        prezzo: +(prezzo * (pr.appoggio.quantita || 0)).toFixed(2),
        // aliquota: pr.appoggio.aliquota || datiDefault.datiFiscali.aliquoteIva[0].valore,
        aliquota: pr.datiFiscali.aliquoteIva[0].valore,
        prezzoAcquisto: acquisto,
        valoreacquisto: +(acquisto * (pr.appoggio.quantita || 0)).toFixed(2)
      },
      quantita: pr.appoggio.quantita || 0,
      // valore: +(prezzo * pr.appoggio.quantita).toFixed(2),
      valore: +(acquisto * (pr.appoggio.quantita || 0)).toFixed(2), // va valutato in base al tipo di movimento fatto
      riferimento: {
        tipo: 'importDati',
        id: String(numeroMovimento).toUpperCase(),
        data: dataJS,
        ordinamento: ordinamento
      },
      anagrafica: {
        cliente: '', // aggiungere esterno, solo se presente nei dati
        fornitore: {
          codice: fornitoreMovimento.codice,
          descrizione: fornitoreMovimento.ragioneSociale
        }
      },
      custom: pr.custom
    }
  })
  const prodottiGiacenza = dati.filter(x => x.appoggio.quantita).map(pr => {
    const pobj = dot.object({ ...pr })
    pobj.codice = sanitize(pobj.codice)
    pobj.marchio = sanitize(pobj.marchio)
    if (pobj.custom && pobj.custom.stagione && pobj.custom.stagione.codice) {
      pobj.custom.stagione.codice = sanitize(pobj.custom.stagione.codice)
    }    
    for (let c = 1; c <= 5; c++) {
      let c_codice = String(_.get(pobj, `varianti.variante${c}.codice`, ''))
      let c_desc = String(_.get(pobj, `varianti.variante${c}.descrizione`, ''))
      if (c_codice.length !== 0 || c_desc.length !== 0) {
        if (c_codice.length === 0) {
          c_codice = c_desc
        }
        if (c_desc.length === 0) {
          c_desc = c_codice
        }
        c_codice = sanitize(c_codice)
        _.set(pobj, `varianti.variante${c}.codice`, c_codice)
        _.set(pobj, `varianti.variante${c}.descrizione`, c_desc)
      }
    }
    for (let c = 1; c <= 5; c++) {
      let c_codice = String(_.get(pobj, `statistici.categoria${c}.codice`, ''))
      let c_desc = String(_.get(pobj, `statistici.categoria${c}.descrizione`, ''))
      if (c_codice.length !== 0 || c_desc.length !== 0) {
        if (c_codice.length === 0) {
          c_codice = c_desc
        }
        if (c_desc.length === 0) {
          c_desc = c_codice
        }
        c_codice = sanitize(c_codice)
        _.set(pobj, `statistici.categoria${c}.codice`, c_codice)
        _.set(pobj, `statistici.categoria${c}.descrizione`, c_desc)
      }
    }     
/*     if (pobj.varianti && pobj.varianti.variante1 && pobj.varianti.variante1.codice) {
      pobj.varianti.variante1.codice = String(pobj.varianti.variante1.codice).toLowerCase() 
    }
    if (pobj.varianti && pobj.varianti.variante2 && pobj.varianti.variante2.codice) {
      pobj.varianti.variante2.codice = String(pobj.varianti.variante2.codice).toLowerCase() 
    } */

    const fornitoreMovimento = fornitore || fornitori.find(x => x.codice === pobj.codiceFornitore) || {}
    delete pobj.codiceFornitore

    pobj.ultimoAcquisto = {
      data: dataJS,
      quantita: pr.appoggio.quantita || 0,
      fornitore: fornitoreMovimento.codice,
      fornitoreDescrizione: fornitoreMovimento.ragioneSociale,
      // prezzo: pr.prezzo.L1.base,
      prezzo: pr.magazzino.prezzoAcquisto, // TODO: verificare
      movimento: numeroMovimento
    }

    return pobj
  })
  try {
    let aggiornaProdotti = true // usato per debug --> se false esclude la creazione dei prodotti ma salva i movimenti
    if (aggiornaProdotti && prodotti && prodotti.length > 0) {
      let start = 0
      let end = 0
      do {
        end = start + 10000
        const sub = prodotti.slice(start, end)
        console.log('prodotti:', start, end)
        await prodottiService.creaProdottiMultipliTestBarcode(sub, 'import: ' + numeroMovimento, usaTagliaColore, false)

        start += 10000
      } while (end < prodotti.length)
    }
    var parametri
    movimenti = movimenti.filter(x => x.quantita)
    if (movimenti && movimenti.length > 0) {  // rivedere come prodotti
      const magazzino = (magazzinoScelto && magazzinoScelto.codice) || valoriDefault.magazzinoMovimento
      const causale = valoriDefault.causaleMovimento
      const causali = await configurazioniService.getConfigurazione('magazzino_causali', 'causali')
      parametri = causali.find(x => x.codice === causale)
      parametri.magazzino = magazzino // TODO: Verificare --> Probabilmente va preso il magazzino selezionato

      let start = 0
      let end = 0
      do {
        end = start + 25
        const sub = movimenti.slice(start, end)
        console.log('movimenti:', start, end)
        await movimentiService.creaMovimentiMultipli(magazzino, parametri, sub)
        start += 25
      } while (end < movimenti.length)
    }
    if (aggiornaProdotti && prodottiGiacenza && prodottiGiacenza.length > 0) {  // rivedere come prodotti
      let start = 0
      let end = 0
      do {
        end = start + 25
        const sub = prodottiGiacenza.slice(start, end)
        console.log('prodottiGiacenza:', start, end)
        await prodottiService.aggiornaGiacenzaMultipla(parametri, sub, usaTagliaColore)

        start += 25
      } while (end < prodottiGiacenza.length)
      return true
    }
    if (!aggiornaProdotti) return true
    return []
  } catch (error) {
    // winston.error(`creaMovimento ordine: ${error}`)
    console.log(`creaMovimento ordine: ${error}`)
    return []
  }
}

export const creaMovimentiSoloNonPresenti = async function (dati, datiDefault, valoriDefault, numeroMovimento, fornitore, dataMovimento, fornitoreSuColonne, usaTagliaColore, magazzinoScelto) {
  const aliquoteIva = await configurazioniService.getConfigurazione('prodotti_aliquote_iva', 'aliquote')
  const repartiFiscali = await configurazioniService.getConfigurazione('prodotti_reparti_fiscali', 'reparti')
  const fornitori = fornitoreSuColonne ? await clientiService.getFornitori() : null

  const idsProdotti = dati.map(pr => {
    const pobj = dot.object({ ...pr })
    const id = (sanitize(pr.codice) + sanitize(_.get(pr, 'varianti.variante1.codice', '') || '') + sanitize(_.get(pr, 'varianti.variante2.codice', '') || '')).toLowerCase()
    return id
  })
  const prodottiEsistenti = await prodottiService.getProdottiByIds(idsProdotti)
  const idEsistenti = prodottiEsistenti.map(x => x._id)

  let prodotti = dati.map(pr => {
    const pobj = dot.object({ ...pr })
    pobj.codice = sanitize(pobj.codice)
    pobj.marchio = sanitize(pobj.marchio)
    if (pobj.custom && pobj.custom.stagione && pobj.custom.stagione.codice) {
      pobj.custom.stagione.codice = sanitize(pobj.custom.stagione.codice)
    }    
    for (let c = 1; c <= 5; c++) {
      let c_codice = String(_.get(pobj, `varianti.variante${c}.codice`, ''))
      let c_desc = String(_.get(pobj, `varianti.variante${c}.descrizione`, ''))
      if (c_codice.length !== 0 || c_desc.length !== 0) {
        if (c_codice.length === 0) {
          c_codice = c_desc
        }
        if (c_desc.length === 0) {
          c_desc = c_codice
        }
        c_codice = sanitize(c_codice)
        _.set(pobj, `varianti.variante${c}.codice`, c_codice)
        _.set(pobj, `varianti.variante${c}.descrizione`, c_desc)
      }
    }
    for (let c = 1; c <= 5; c++) {
      let c_codice = String(_.get(pobj, `statistici.categoria${c}.codice`, ''))
      let c_desc = String(_.get(pobj, `statistici.categoria${c}.descrizione`, ''))
      if (c_codice.length !== 0 || c_desc.length !== 0) {
        if (c_codice.length === 0) {
          c_codice = c_desc
        }
        if (c_desc.length === 0) {
          c_desc = c_codice
        }
        c_codice = sanitize(c_codice)
        _.set(pobj, `statistici.categoria${c}.codice`, c_codice)
        _.set(pobj, `statistici.categoria${c}.descrizione`, c_desc)
      }
    }    
/*     if (pobj.varianti && pobj.varianti.variante1 && pobj.varianti.variante1.codice) {
      pobj.varianti.variante1.codice = String(pobj.varianti.variante1.codice).toLowerCase() 
    }
    if (pobj.varianti && pobj.varianti.variante2 && pobj.varianti.variante2.codice) {
      pobj.varianti.variante2.codice = String(pobj.varianti.variante2.codice).toLowerCase() 
    } */
    let iva = aliquoteIva.find(x => String(x.codice) === String(pobj.appoggio.aliquota))
    let reparto = repartiFiscali.find(x => String(x.codice).toUpperCase() === String(pobj.appoggio.repartoFiscale).toUpperCase() || String(x.stampante.numero).toUpperCase() === String(pobj.appoggio.repartoFiscale))
    delete pobj.appoggio // toglie tutti i dati che non devono andare nel db prodotti
    _.merge(pobj, datiDefault)
    if (iva && reparto) {
      delete pobj.datiFiscali
      pobj.datiFiscali = {
        aliquoteIva: [{
          codice: iva.codice,
          valore: iva.aliquota,
          descrizione: iva.descrizione,
          tipoApplicazione: 'banco' // eventualmente passare
        }],
        reparto: {
          codice: reparto.codice,
          descrizione: reparto.descrizione,
          stampante: reparto.stampante.numero
        }
      }
    }
    if (pobj.magazzino.prezzoAcquisto) {
      pobj.magazzino.prezzoAcquisto = +pobj.magazzino.prezzoAcquisto.toFixed(2)
    }

    pobj.magazzino.unitaMisura = pobj.magazzino.unitaMisura || 'n'

    if (pobj.prezzo.L1 && pobj.prezzo.L1.base) pobj.prezzo.L1.base = +pobj.prezzo.L1.base.toFixed(2)
    if (pobj.prezzo.L2 && pobj.prezzo.L2.base) pobj.prezzo.L2.base = +pobj.prezzo.L2.base.toFixed(2)
    if (pobj.prezzo.L3 && pobj.prezzo.L3.base) pobj.prezzo.L3.base = +pobj.prezzo.L3.base.toFixed(2)
    if (pobj.prezzo.L4 && pobj.prezzo.L4.base) pobj.prezzo.L4.base = +pobj.prezzo.L4.base.toFixed(2)
    if (pobj.prezzo.L5 && pobj.prezzo.L5.base) pobj.prezzo.L5.base = +pobj.prezzo.L5.base.toFixed(2)

    delete pobj.codiceFornitore
    return pobj
  })
  console.log(prodotti.length)
  prodotti = prodotti.filter(pr => {
    const id = (sanitize(pr.codice) + sanitize(_.get(pr, 'varianti.variante1.codice', '') || '') + sanitize(_.get(pr, 'varianti.variante2.codice', '') || '')).toLowerCase()
    return !idEsistenti.includes(id)
  })
  console.log(prodotti.length)

  const dataJS = moment(dataMovimento, 'YYYY-MM-DD').utcOffset(0, true).format()
  let ordinamento = 0
  let movimenti = dati.map(pr => {
    ordinamento++
    const pobj = dot.object(pr)
    pobj.codice = sanitize(pobj.codice)
    pobj.marchio = sanitize(pobj.marchio)
    if (pobj.custom && pobj.custom.stagione && pobj.custom.stagione.codice) {
      pobj.custom.stagione.codice = sanitize(pobj.custom.stagione.codice)
    }    
    for (let c = 1; c <= 5; c++) {
      let c_codice = String(_.get(pobj, `varianti.variante${c}.codice`, ''))
      let c_desc = String(_.get(pobj, `varianti.variante${c}.descrizione`, ''))
      if (c_codice.length !== 0 || c_desc.length !== 0) {
        if (c_codice.length === 0) {
          c_codice = c_desc
        }
        if (c_desc.length === 0) {
          c_desc = c_codice
        }
        c_codice = sanitize(c_codice)
        _.set(pobj, `varianti.variante${c}.codice`, c_codice)
        _.set(pobj, `varianti.variante${c}.descrizione`, c_desc)
      }
    }
    for (let c = 1; c <= 5; c++) {
      let c_codice = String(_.get(pobj, `statistici.categoria${c}.codice`, ''))
      let c_desc = String(_.get(pobj, `statistici.categoria${c}.descrizione`, ''))
      if (c_codice.length !== 0 || c_desc.length !== 0) {
        if (c_codice.length === 0) {
          c_codice = c_desc
        }
        if (c_desc.length === 0) {
          c_desc = c_codice
        }
        c_codice = sanitize(c_codice)
        _.set(pobj, `statistici.categoria${c}.codice`, c_codice)
        _.set(pobj, `statistici.categoria${c}.descrizione`, c_desc)
      }
    }    
/*     if (pobj.varianti && pobj.varianti.variante1 && pobj.varianti.variante1.codice) {
      pobj.varianti.variante1.codice = String(pobj.varianti.variante1.codice).toLowerCase() 
    }
    if (pobj.varianti && pobj.varianti.variante2 && pobj.varianti.variante2.codice) {
      pobj.varianti.variante2.codice = String(pobj.varianti.variante2.codice).toLowerCase() 
    } */
    let iva = aliquoteIva.find(x => String(x.codice) === String(pobj.appoggio.aliquota))
    let reparto = repartiFiscali.find(x => String(x.codice).toUpperCase() === String(pobj.appoggio.repartoFiscale).toUpperCase() || String(x.stampante.numero).toUpperCase() === String(pobj.appoggio.repartoFiscale))
    _.merge(pobj, datiDefault)
    if (iva && reparto) {
      delete pobj.datiFiscali
      pobj.datiFiscali = {
        aliquoteIva: [{
          codice: iva.codice,
          valore: iva.aliquota,
          descrizione: iva.descrizione,
          tipoApplicazione: 'banco' // eventualmente passare
        }],
        reparto: {
          codice: reparto.codice,
          descrizione: reparto.descrizione,
          stampante: reparto.stampante.numero
        }
      }
    } 
    const prezzo = pr.prezzo[valoriDefault.listinoVendita].base
    const acquisto = pr.magazzino.prezzoAcquisto
    const fornitoreMovimento = fornitore || fornitori.find(x => x.codice === pobj.codiceFornitore) || {}

    return {
      data: dataJS,
      prodotto: {
        codice: usaTagliaColore ? (sanitize(pr.codice) + sanitize(pr.varianti.variante1.codice || '') + sanitize(pr.varianti.variante2.codice || '')).toLowerCase() : sanitize(pr.codice).toLowerCase(),
        quantita: pr.appoggio.quantita || 0,
        um: pr.magazzino.unitaMisura,
        prezzoUnitario: prezzo,
        prezzo: +(prezzo * (pr.appoggio.quantita || 0)).toFixed(2),
        // aliquota: pr.appoggio.aliquota || datiDefault.datiFiscali.aliquoteIva[0].valore,
        aliquota: pr.datiFiscali.aliquoteIva[0].valore,
        prezzoAcquisto: acquisto,
        valoreacquisto: +(acquisto * (pr.appoggio.quantita || 0)).toFixed(2)
      },
      quantita: pr.appoggio.quantita || 0,
      // valore: +(prezzo * pr.appoggio.quantita).toFixed(2),
      valore: +(acquisto * (pr.appoggio.quantita || 0)).toFixed(2), // va valutato in base al tipo di movimento fatto
      riferimento: {
        tipo: 'importDati',
        id: String(numeroMovimento).toUpperCase(),
        data: dataJS,
        ordinamento: ordinamento
      },
      anagrafica: {
        cliente: '', // aggiungere esterno, solo se presente nei dati
        fornitore: {
          codice: fornitoreMovimento.codice,
          descrizione: fornitoreMovimento.ragioneSociale
        }
      },
      custom: pr.custom
    }
  })
  console.log(movimenti.length)
  movimenti = movimenti.filter(x => !idEsistenti.includes(x.prodotto.codice))
  console.log(movimenti.length)


  let prodottiGiacenza = dati.filter(x => x.appoggio.quantita).map(pr => {
    const pobj = dot.object({ ...pr })
    pobj.codice = sanitize(pobj.codice)
    pobj.marchio = sanitize(pobj.marchio)
    if (pobj.custom && pobj.custom.stagione && pobj.custom.stagione.codice) {
      pobj.custom.stagione.codice = sanitize(pobj.custom.stagione.codice)
    }    
    for (let c = 1; c <= 5; c++) {
      let c_codice = String(_.get(pobj, `varianti.variante${c}.codice`, ''))
      let c_desc = String(_.get(pobj, `varianti.variante${c}.descrizione`, ''))
      if (c_codice.length !== 0 || c_desc.length !== 0) {
        if (c_codice.length === 0) {
          c_codice = c_desc
        }
        if (c_desc.length === 0) {
          c_desc = c_codice
        }
        c_codice = sanitize(c_codice)
        _.set(pobj, `varianti.variante${c}.codice`, c_codice)
        _.set(pobj, `varianti.variante${c}.descrizione`, c_desc)
      }
    }
    for (let c = 1; c <= 5; c++) {
      let c_codice = String(_.get(pobj, `statistici.categoria${c}.codice`, ''))
      let c_desc = String(_.get(pobj, `statistici.categoria${c}.descrizione`, ''))
      if (c_codice.length !== 0 || c_desc.length !== 0) {
        if (c_codice.length === 0) {
          c_codice = c_desc
        }
        if (c_desc.length === 0) {
          c_desc = c_codice
        }
        c_codice = sanitize(c_codice)
        _.set(pobj, `statistici.categoria${c}.codice`, c_codice)
        _.set(pobj, `statistici.categoria${c}.descrizione`, c_desc)
      }
    }     
/*     if (pobj.varianti && pobj.varianti.variante1 && pobj.varianti.variante1.codice) {
      pobj.varianti.variante1.codice = String(pobj.varianti.variante1.codice).toLowerCase() 
    }
    if (pobj.varianti && pobj.varianti.variante2 && pobj.varianti.variante2.codice) {
      pobj.varianti.variante2.codice = String(pobj.varianti.variante2.codice).toLowerCase() 
    } */
    const fornitoreMovimento = fornitore || fornitori.find(x => x.codice === pobj.codiceFornitore) || {}

    pobj.ultimoAcquisto = {
      data: dataJS,
      quantita: pr.appoggio.quantita || 0,
      fornitore: fornitoreMovimento.codice,
      fornitoreDescrizione: fornitoreMovimento.ragioneSociale,
      // prezzo: pr.prezzo.L1.base,
      prezzo: pr.magazzino.prezzoAcquisto, // TODO: verificare
      movimento: numeroMovimento
    }
    return pobj
  })
  console.log(prodottiGiacenza.length)
  prodottiGiacenza = prodottiGiacenza.filter(pr => {
    const id = (sanitize(pr.codice) + sanitize(_.get(pr, 'varianti.variante1.codice', '') || '') + sanitize(_.get(pr, 'varianti.variante2.codice', '') || '')).toLowerCase()
    return !idEsistenti.includes(id)
  })
  console.log(prodottiGiacenza.length)
  try {
    let aggiornaProdotti = true // usato per debug --> se false esclude la creazione dei prodotti ma salva i movimenti
    if (aggiornaProdotti && prodotti && prodotti.length > 0) {
      let start = 0
      let end = 0
      do {
        end = start + 10000
        const sub = prodotti.slice(start, end)
        console.log('prodotti:', start, end)
        await prodottiService.creaProdottiMultipliTestBarcode(sub, 'import: ' + numeroMovimento, usaTagliaColore, false)

        start += 10000
      } while (end < prodotti.length)
    }
    var parametri
    movimenti = movimenti.filter(x => x.quantita)
    if (movimenti && movimenti.length > 0) {  // rivedere come prodotti
      const magazzino = (magazzinoScelto && magazzinoScelto.codice) || valoriDefault.magazzinoMovimento
      const causale = valoriDefault.causaleMovimento
      const causali = await configurazioniService.getConfigurazione('magazzino_causali', 'causali')
      parametri = causali.find(x => x.codice === causale)
      parametri.magazzino = magazzino // TODO: Verificare --> Probabilemente va preso il magazzino selezionato

      let start = 0
      let end = 0
      do {
        end = start + 25
        const sub = movimenti.slice(start, end)
        console.log('movimenti:', start, end)
        await movimentiService.creaMovimentiMultipli(magazzino, parametri, sub)
        start += 25
      } while (end < movimenti.length)
    }
    if (aggiornaProdotti && prodottiGiacenza && prodottiGiacenza.length > 0) {  // rivedere come prodotti
      let start = 0
      let end = 0
      do {
        end = start + 25
        const sub = prodottiGiacenza.slice(start, end)
        console.log('prodottiGiacenza:', start, end)
        await prodottiService.aggiornaGiacenzaMultipla(parametri, sub, usaTagliaColore)

        start += 25
      } while (end < prodottiGiacenza.length)
      return true
    }
    if (!aggiornaProdotti) return true
    return []
  } catch (error) {
    // winston.error(`creaMovimento ordine: ${error}`)
    console.log(`creaMovimento ordine: ${error}`)
    return []
  }
}
